import { paymentsApi, type PaymentStatus } from '@/api/paymentsApi';

const TERMINAL: PaymentStatus[] = ['success', 'failed', 'refunded'];

/**
 * Poll until the server reaches a terminal status.
 *
 * Needed because the webhook and the shopper's return race each other: the
 * customer is often back before Cashfree has called us. Bounded on purpose —
 * each poll costs a gateway lookup, and anything still unresolved is picked up
 * by the reconcile_payments cron.
 */
export async function pollPaymentStatus(
  paymentId: string,
  { attempts = 12, intervalMs = 2500, signal }: {
    attempts?: number; intervalMs?: number; signal?: AbortSignal;
  } = {},
): Promise<PaymentStatus> {
  let last: PaymentStatus = 'pending';
  for (let i = 0; i < attempts; i += 1) {
    if (signal?.aborted) return last;
    try {
      const { data } = await paymentsApi.getStatus(paymentId);
      last = data.status;
      if (TERMINAL.includes(last)) return last;
    } catch {
      // Transient: keep trying, the cron is the backstop.
    }
    if (i < attempts - 1) {
      await new Promise((r) => setTimeout(r, intervalMs));
    }
  }
  return last;
}
